import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

const FREE_DELIVERY__ICON_WIDTH = 16;

export const outOfStockLabel = css`
  ${theme.responsiveText.BODY.XS};
  font-family: ${fonts.PRIMARY_REGULAR.family};
  margin: 0;
`;

export const product = css`
  grid-column: span 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  border-radius: ${pxToRem(10)};
`;

export const productHeading = css`
  display: grid;
  margin: 0;
`;

export const skeletonLabelContainer = css`
  grid-row: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${spacing.xxxl}px ${spacing.xl}px ${pxToRem(44)};
`;

export const productLabel = css`
  position: absolute;
  top: ${pxToRem(15)};
  left: 0;
  padding: 0 ${spacing.xs}px;
  ${theme.responsiveText.BODY.XS};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
`;

export const productTitle = css`
  grid-row: 2;
  margin-bottom: ${spacing.base}px;
  ${theme.responsiveText.BODY.SM};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
`;

export const productPrices = css`
  display: flex;
  grid-row: 3;
`;

export const productPrice = css`
  margin-top: 0;
  ${theme.responsiveText.BODY.SM};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
`;

export const productPreviousPrice = css`
  ${productPrice};
  margin-left: ${spacing.xs}px;
`;

export const labelWrapper = css`
  display: block;
  margin: 0 0 ${spacing.sm}px;
`;

export const fitImageToContainer = css`
  object-fit: cover;
`;

export const freeDeliveryLabelWrapper = css`
  display: grid;
  grid-template-columns: auto 1fr;
`;

export const freeDelivery = css`
  display: inline-flex;
  padding: ${spacing.xs}px ${spacing.base / 2}px;
  gap: ${pxToRem(spacing.xs)};
  border-radius: ${pxToRem(6)};
  color: var(--neutral-black-base);
  ${theme.responsiveText.BODY.XS}
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  background-color: var(--neutral-black-10);
`;

export const freeDeliveryIcon = css`
  flex: 0 0 ${pxToRem(FREE_DELIVERY__ICON_WIDTH)};

  ${mediaQuery(
    { max: maxBreakpoints.S },
    css`
      display: none;
    `,
  )};
`;
